import HorizontalRule from "../../../../components/HorizontalRule/HorizontalRule";
import { buildEndpoint } from "../../../../services/api.service";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { useState } from "react";
import { palette } from "../../../../assets/theme/theme";


export default function FotoOperacaoDisplay({ fotos, pecaId, operacaoId, expedicaoId } : any) {

    const [thumbnailsToShow, setThumbnailsToShow] = useState<number[]>([]);


    const removeThumbnail = (idx : number) => {
        setThumbnailsToShow(thumbnailsToShow.filter(t => t != idx));
    }

    const isShowing = (idx : number) => {
        return thumbnailsToShow.includes(idx);
    }


    return (<div className="w-full mb-3">

        <div style={{marginLeft: 20}}>
       
               <>{fotos.map((foto : any, i : number) => <div style={{ width: '100%'}}>
                <div style={{marginTop: 30, marginRight: 40, display: 'flex', alignItems:'center', justifyContent: 'space-between'}}>
            
                <div style={{alignItems: 'center', display: 'flex'}}>
                    <span style={{ fontWeight: 'bold', marginRight: 20 }}>Imagem {i + 1}</span>
                    {isShowing(i)?<VisibilityOffIcon onClick={()=> removeThumbnail(i)}/> : <VisibilityIcon onClick={()=> setThumbnailsToShow([...thumbnailsToShow, i])}/>}
               </div>               
               <div style={{alignItems: 'center', display: 'flex'}}>
                   <a style={{marginRight: 20}} href={buildEndpoint(`/pecas/${pecaId}/operacao/${operacaoId}/download/${foto.id}`)} target='__blank'>
                       <OpenInNewIcon/>
                   </a>
               </div>
       </div>
       {isShowing(i)?<div style={{marginTop: 20, marginRight: 20}}><img src={buildEndpoint(`/pecas/${pecaId}/operacao/${operacaoId}/download/${foto.id}`)} width={400} height={400} /></div> : null}

       {i < fotos.length -1 ? <HorizontalRule style={{border: `1px solid ${palette.gray.dark}`}}/> : null}
       </div>
       )}</>
        
        </div>

     



    </div>)


}

